<template>
  <div>
    <div class="order-info">
      <el-card shadow="hover" class="cursor margin-bottom-10" @click.native="handleDetail">
        <el-row>
          <el-col :span="4">
            <img v-if="info.applyType === '02'" src="../../../../assets/images/materials@2x.png" />
            <img
              v-else-if="info.applyType === '04'"
              :src="
                info.circlePocImage
                  ? info.circlePocImage
                  : require('../../../../assets/images/pbo.png')
              "
            />
            <img v-if="!['02', '04'].includes(info.applyType)" :src="getImageUrl(info) || require('@/assets/images/poc_photo_default.png')" />
            <div class="trade-date" v-if="info.finishTime && info.finishTime !==null">{{ info.finishTime | parseTime("{y}-{m}-{d}") }}</div>
            <div class="trade-date" v-else>{{ info.applyDate | parseTime("{y}-{m}-{d}") }}</div>
          </el-col>
          <el-col :span="9">
            <div class="trade-store-name margin-top-15" v-if="info.applyType == '02'">{{ info.eventSubject }}</div>
            <div class="trade-store-name margin-top-15" v-else-if="info.applyType === '04'">{{ info.circlePocName }}</div>
            <div class="trade-store-name margin-top-15" v-else>{{ info.pocName }}</div>
            <div class="margin-top-15">
              {{ info.applyClientLevelName }}-{{
              info.applyClientName
              }}&nbsp;&nbsp;{{ info.buName }} - {{ info.regionName && info.regionName }}
            </div>
            <!-- v-for="(tItem, index) in typeList"
            :key="index"  {{ tItem }}-->
            <el-button size="small" class="btn-grey-plain btn margin-top-15" style="cursor: auto">{{ info.execTypeSubName }}</el-button>
          </el-col>
          <el-col :span="11" style="text-align: right">
            <el-row>
              <div class="margin-bottom-10" style="color: #c8102d; font-weight: bold">{{ info.applyStatusName }}</div>
            </el-row>
            <el-row>
              <div class="margin-bottom-10 trade-store-number">
                {{ info.applyNumber }}
                <img v-if="extendImgShow" src="../../../../assets/images/extend-box.png" />
              </div>
            </el-row>
            <el-row>
              <div class="margin-bottom-10" v-if="info.applyType === '04'">{{ info.circlePocAddress }}</div>
              <div class="margin-bottom-10" v-else>{{ info.vendorName }}</div>
            </el-row>
            <el-row>
              <el-col class="margin-bottom-10" :span="info.actualAmount?12:24" v-show="info.quoteAmount">
                报价金额：{{
                (info.quoteAmount || 0).toFixed(2) | thousandSymbol
                }}元
              </el-col>
              <el-col
                :span="info.quoteAmount?12:24"
                class="margin-bottom-10"
                v-show="info.actualAmount"
              >实际金额：{{ (info.actualAmount || 0).toFixed(2) | thousandSymbol}}元</el-col>
            </el-row>
            <el-row>
              <el-col class="margin-bottom-10"  v-show="isSubmissionTime">
                供应商提交时间：{{ supplierApplyTime | parseTime("{y}-{m}-{d} {h}:{i}") }}
              </el-col>
            </el-row>

            <el-row v-if="info.quoteAmount">
              <el-button class="btn-red" size="small" @click.stop="getPackAccessory(info.applyId)">打包附件</el-button>
              <el-button class="btn-red" style="margin-right: 0" size="small" @click.stop="handleExport()">下载报价</el-button>
            </el-row>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <v-form ref="form" :url="exportUrl" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import vForm from '@/components/v-form'
import { commonUtils } from '@/utils/common'

export default {
  props: {
    isSubmissionTime: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      typeList: [],
      checked: false,
      exportUrl: null
    }
  },
  components: {
    vForm
  },
  computed: {
    ...mapGetters(['userInfo']),
    extendImgShow () {
      if (this.info) {
        if (this.info.execList?.length) {
          return this.info.mainApplyId && !this.info.execList[0].execCoolerList
        }
      }
      return false
    },

    supplierApplyTime() {
      if (this.info.finishTime && this.info.quoteDate) {
        return Math.max(this.info.finishTime, this.info.quoteDate)
      }
      return this.info.finishTime || this.info.quoteDate
    }
  },
  // watch: {
  //   info: {
  //     immediate: true,
  //     deep: true,
  //     handler () {
  //       this.getOrderType(this.info)
  //     }
  //   }
  // },
  methods: {
    // 打包附件
    getPackAccessory () {
      this.exportUrl = commonUtils.getApiUrl(`/bcc/pack/${this.info.applyId}`)
      this.$confirm('是否要打包附件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      })
        .then(() => {
          this.$refs.form.submit()
        })
        .catch(() => { })
    },
    // 下载报价
    handleExport () {
      this.exportUrl = commonUtils.getApiUrl(`/bcc/download/${this.info.applyId}`)
      this.$confirm('是否要下载报价单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      })
        .then(() => {
          this.$refs.form.submit()
        })
        .catch(() => { })
    },
    getImageUrl (info) {
      if(info.basePocDTO?.pocOutsidePhotoUri) {
        return commonUtils.getImageUrl(info.basePocDTO?.pocOutsidePhotoUri)
      } else {
        return ''
      }
    },

    confirmText (type) {
      if (type === 'waitCheck') {
        return '确认验收'
      }
      if (type === 'waitAccept') {
        return '确认收货'
      }
    },

    // 获取订单类型
    getOrderType (info) {
      let typeList = []
      if (info.applyType === '02') {
        typeList.push('批量化物料')
        this.typeList = typeList
        return
      }
      info.execList.forEach((item) => {
        typeList.push(this.setTypeText(item.execTypeSub))
      })
      this.typeList = typeList
    },

    // 订单类型
    setTypeText (val) {
      const typeObj = {
        201: '门店定制',
        301: 'ISP高端执行',
        302: 'ISP形象店',
        303: 'ISP物料定制'
      }
      return typeObj[val] || ''
    },

    infoCheck (val) {
      this.$emit('infoCheck')
    },

    handleClick (val, id, applyType) {
      let data = {
        type: val,
        applyId: id,
        applyType: applyType,
        orderInfo: this.info
      }
      this.$emit('handleClick', data)
    },

    // 查看详情
    handleDetail () {
      let routerPath = '/bcc/order-info'
      // if (this.info.execList) {
      //   if (['105', '106', '107', '108'].includes(this.info.execList[0].execTypeSub)) {
      //     routerPath = '/trade/perfect-order-info'
      //   }
      // }
      this.$router.push({
        path: routerPath,
        query: {
          applyId: this.info.applyId
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.margin-bottom-10 {
  margin-bottom: 10px;
}
.margin-top-15 {
  margin-top: 15px;
}
.order-info {
  position: relative;

  .el-card {
    border-radius: 8px;
  }
}
.check-box {
  position: absolute;
  top: 50%;
  left: -30px;
  transform: translateY(-50%);
  zoom: 140%;
}
.btn {
  height: 26px;
  padding: 0 15px;
  text-align: center;
  border-radius: 13px;
  line-height: 5px;
}
.batch-btn {
  margin-left: 45%;
  background-color: $base-white;
  color: $base-dark;
  border-color: $base-dark;
}
img,
.photo {
  width: 100px;
  height: 100px;
  border-radius: 6px;
  object-fit: cover;
}
.trade-date {
  width: 100px;
  color: #666666;
  font-size: 14px;
  text-align: center;
  padding-top: 5px;
}
.order-info .el-button {
  margin-left: 0px;
  margin-right: 10px;
}

.btn-grey-plain {
  color: #888;
  border-color: #888;
}

.trade-store-name {
  font-size: 18px;
  font-weight: bold;
}
.trade-store-number {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  img {
    width: 20px;
    height: 20px;
    margin-left: 8px;
  }
}
</style>
